import { CardActions, CardContent, Collapse, Divider, styled } from "@mui/material";
import { IFutureExtended, IPairExtended } from "../PairSpreadItem/PairSpreadItem";
import IconButton from '@mui/material/IconButton';
import { useState } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { trueDaysForm } from "../../utils/true.word.form";
import { unixToShortString } from "../../utils/time";

export const FeaturesBlock: React.FC<IPairExtended> = (pairData: IPairExtended) => { 
    const [expanded, setExpanded] = useState(false);

    const ExpandMore = styled((props: any) => {
        const { expand, ...other } = props;
            return <IconButton {...other} />;
        })(({ theme, expand }) => ({
            transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
            marginLeft: 'auto',
            marginTop: 0,
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shortest,
            }),
    }));

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const getFutureItem = (future: IFutureExtended) => {
        const daysLeft = future.daysLeft < 1 ? future.daysLeft : Math.floor(future.daysLeft);
        return (
            <div className='futures'>
                <div className='container'>
                    { `${future.shortName} (${future.code}):` }
                    {<span className='price'>{ future.price ? `${future.price.bid.toFixed(future.decimals)} руб.` : 'Нет цены'}</span>}
                </div>
                <div className='container'>
                    { `Спред` }
                    {<span className='price'>{ `${(future.spreadRate * 100)?.toFixed(2)}%` }</span>}
                </div>
                <div className='container'>
                    { `Экспирация`}
                    <div>
                        <div className='price'>{`${unixToShortString(future.deliveryDate)}`}</div>
                        <div className='smallPrice'>{`${daysLeft} ${trueDaysForm(future.daysLeft)}`}</div>
                    </div>
                </div>
                <div className='container'>
                    { `Год. доходность`}
                    <span className='price'>{`${(future.yearProfit * 100)?.toFixed(2)}%` }</span>
                </div>
                <div className='container'>
                    { `Размер ГО` }
                    <div>
                        {<div className='price'>{`${future.initialMargin?.toFixed(2)} руб.`}</div>}
                        {<div className='smallPrice'>{`${future.initialMarginPercent?.toFixed(1)}%`}</div>}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <CardActions disableSpacing className='expandCont'>
                <span className='expandTitle'>{ 'Фьючерсы' }</span>
                <ExpandMore
                    expand={ expanded }
                    onClick={ handleExpandClick }
                    aria-expanded={ expanded }
                    aria-label="Подробнее"
                >
                    <ExpandMoreIcon />
                </ExpandMore>
            </CardActions>
            
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent className='cardContent'>
                    { getFutureItem(pairData.futNear) }
                    <Divider />
                    { getFutureItem(pairData.futFar) }
                </CardContent>
            </Collapse>
        </>
    );
}